import { render, staticRenderFns } from "./FormPricing.vue?vue&type=template&id=154c4df1&"
import script from "./FormPricing.vue?vue&type=script&lang=js&"
export * from "./FormPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports